import { render, staticRenderFns } from "./DocumentTracking.vue?vue&type=template&id=528acb73&"
import script from "./DocumentTracking.vue?vue&type=script&lang=js&"
export * from "./DocumentTracking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports